module.exports = __webpack_public_path__ + "static/fonts/ionicons.woff";


//////////////////
// WEBPACK FOOTER
// ./~/iview/dist/styles/fonts/ionicons.woff?v=3.0.0
// module id = 89
// module chunks = 83